import { AxiosResponse } from 'axios';
import { axiosInstance } from 'hooks/auth/AxiosInstance';
import { UseQueryResult, useQuery } from '@tanstack/react-query';

/** Row shape from GET payments/driver (fields may vary by API). */
export interface DriverRecord {
  id?: string | number;
  name?: string;
  lastName?: string;
  vehicleRegistrationNumber?: string;
  phoneNumber?: string;
}

const normalizeDrivers = (payload: unknown): DriverRecord[] => {
  if (Array.isArray(payload)) {
    return payload as DriverRecord[];
  }
  if (payload && typeof payload === 'object') {
    const o = payload as Record<string, unknown>;
    if (Array.isArray(o.data)) return o.data as DriverRecord[];
    if (Array.isArray(o.content)) return o.content as DriverRecord[];
    if (Array.isArray(o.drivers)) return o.drivers as DriverRecord[];
    if (Array.isArray(o.driverList)) return o.driverList as DriverRecord[];
  }
  return [];
};

const fetchDrivers = async (): Promise<DriverRecord[]> => {
  const response: AxiosResponse<unknown> = await axiosInstance.get(
    'owner-vehicle-details',
  );
  return normalizeDrivers(response.data);
};

const useGetDrivers = (): UseQueryResult<DriverRecord[], Error> => {
  return useQuery<DriverRecord[], Error>({
    queryKey: ['drivers'],
    queryFn: fetchDrivers,
    refetchOnWindowFocus: false,
  });
};

export default useGetDrivers;
